export enum DispenserType {
  TORK_LIBRA_DISPENSER = 'Tork Dispensers',
  EASY_CUBE = 'Easy Cube',
  IDENTIFI = 'Identifi',
  SMART_CARE = 'Smart Care',
  LIBRA_PERIOD_POSITIVITY_PROGRAM = 'Libra Period Positivity Program'
}

export enum ShipmentType {
  CREDIT_NOTE = 'Requesting credit note',
  SHIP_TO_CUSTOMER = 'Ship to end customer depot',
  SHIP_TO_DISTRIBUTOR = 'Ship to distributor depot'
}

export enum DispenserCreditClaimHistoryStatus {
  PLACED = 'PLACED',
  COMPLETED = 'COMPLETED'
}

export enum DispenserCreditClaimDetailStatus {
  PLACED = 'PLACED',
  COMPLETED = 'COMPLETED'
}
